import { Component, OnInit } from '@angular/core';
import { RestService } from 'src/app/datasource/rest.service';

@Component({
  selector: 'app-queue',
  templateUrl: './queue.component.html',
  styleUrls: ['./queue.component.less']
})
export class EmailsQueueComponent implements OnInit {

  public method = "apps/index/format/json/";
  public list = [];

  constructor(private RService: RestService) { }

  ngOnInit(): void {
    this.RService.get(this.method).subscribe((response: any) => {
    if (response.status === true) {
        this.list = response.result;
      }
    });
  }

}
